module.exports = __webpack_public_path__ + "static/media/team_5.5cb15fa6.jpg";